import { useEffect, useState } from 'react'
import Tabs from '@/components/Tabs'
import LoginPanel from './LoginPanel'
import RegisterPanel from './RegisterPanel'


export default function AuthModal() {
  const [categories] = useState([
    {
      key: 'login',
      title: 'Login',
      panel: <LoginPanel />
    },
    {
      key: 'register',
      title: 'Register',
      panel: <RegisterPanel />
    },
  ])

  return (
    <div className="flex h-full">
      <div className="flex-1 p-6">
        <Tabs items={categories} />
      </div>
      <div className="hidden lg:block flex-1 relative rounded-r-2xl">
        <img className="absolute object-cover inset-0 h-full w-full rounded-r-2xl" src="/authman.png" alt="" />
      </div>
    </div>
  )
}